import { useCallback, useEffect, useState } from "react"
import { Route, Routes, useLocation } from "react-router-dom"
import { api } from "../lib/api"
import type { Me } from "../types"
import { Carregando } from "./ui"
import { Casca } from "./ui/Casca"
import Painel from "./Painel"
import Simulado from "./Simulado"
import Resultado from "./Resultado"
import Historico from "./Historico"
import Configuracoes from "./Configuracoes"
import Acesso from "./Acesso"
import Suporte from "./Suporte"
import Chamado from "./Suporte/Chamado"

export default function App() {
  const [me, setMe] = useState<Me | null>(null)
  const local = useLocation()

  const recarregar = useCallback(async () => {
    setMe(await api.get<Me>("/me"))
  }, [])

  useEffect(() => {
    recarregar()
  }, [recarregar])

  // Dentro do simulado a casca some: o candidato tem uma tarefa só.
  const emProva = local.pathname.startsWith("/simulado/") && !local.pathname.endsWith("/resultado")

  if (!me) return <Carregando />

  const telas = (
    <Routes>
      <Route path="/" element={<Painel me={me} recarregar={recarregar} />} />
      <Route path="/painel" element={<Painel me={me} recarregar={recarregar} />} />
      <Route path="/simulado/:id" element={<Simulado recarregar={recarregar} />} />
      <Route path="/simulado/:id/resultado" element={<Resultado />} />
      <Route path="/acesso" element={<Acesso />} />
      <Route path="/historico" element={<Historico />} />
      <Route path="/suporte" element={<Suporte />} />
      <Route path="/suporte/:id" element={<Chamado />} />
      <Route path="/configuracoes" element={<Configuracoes me={me} recarregar={recarregar} />} />
    </Routes>
  )

  if (emProva) return <div className="min-h-[100dvh] bg-areia">{telas}</div>

  return <Casca admin={me.usuario.admin}>{telas}</Casca>
}
